export default "__VITE_ASSET__DCSps_Av__"